export const LABELS = {
    SALE: 'Sale',
    SHOP_ALL: 'Shop All',
    LIMITED_SIZES: 'Limited Sizes',
    SOLD_OUT: 'Sold Out',
    MOST_POPULAR: 'Most Popular',
    FREE_SHIPPING: 'Free Shipping',
    CUSTOMIZE: 'Customize'
}